import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { sanitizeFilename } from '../shared/utils/file-utils';

/**
 * Interceptor that catches outgoing FormData requests and sanitizes filenames
 * of any File objects to prevent ERR_INVALID_CHAR in headers on the server.
 */
@Injectable()
export class FileSanitizeInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.body instanceof FormData) {
      const originalFormData = req.body;
      const newFormData = new FormData();
      let modified = false;

      // We use the forEach method of FormData to iterate over its entries.
      // value can be a string or a Blob (which includes File).
      originalFormData.forEach((value, key) => {
        if (value instanceof File) {
          const sanitizedName = sanitizeFilename(value.name);
          if (sanitizedName !== value.name) {
            modified = true;
          }
          newFormData.append(key, value, sanitizedName);
        } else {
          newFormData.append(key, value);
        }
      });

      if (modified) {
        req = req.clone({ body: newFormData });
      }
    }

    return next.handle(req);
  }
}
